var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-header"},[_c('profile-title'),_vm._l((_vm.links),function(link){return _c('router-link',{key:link.title,attrs:{"to":{name: link.to}}},[_vm._v(" "+_vm._s(link.title)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }